import { h } from 'preact';
import Image from 'utils/image';
import { useMemo } from 'preact/hooks';

const OptionValue = ({
  value,
  isQuickView,
  selectedOption,
  optionId,
  productId,
  handleVariantChange,
  currentVariant,
  option,
  product,
}) => {
  const variant = useMemo(() => {
    const options = Object.fromEntries(
      currentVariant.selectedOptions.map((item) => {
        if (item.name === option.name) {
          return [
            item.name,
            {
              ...item,
              value,
            },
          ];
        }
        return [item.name, item];
      }),
    );

    return product.variants.find((v) =>
      v.selectedOptions.every(
        (item) => item.value === options[item.name].value,
      ),
    );
  }, [currentVariant]);

  const swatchSrc =
    variant && typeof variant.swatchImage == 'object'
      ? variant.swatchImage?.src
      : variant && variant.swatchImage ? variant.swatchImage : '';
  return (
    variant &&
    <div
      key={`${optionId}-${value}`}
      className={`relative flex items-center 
          w-[34px] h-[34px] mr-1 mb-1.5 ${selectedOption?.value === value ? ' border-black' : 'border-grey-3'
        }`}
    >
      <input
        type="radio"
        id={`${isQuickView ? 'qw' : ''}${productId}-${value.replace(' ', '')}`}
        name={`${productId}-${option.name}`}
        value={value}
        checked={selectedOption?.value === value}
        onChange={handleVariantChange}
        data-option-name={option.name}
        className="peer absolute opacity-0 cursor-pointer focus:opacity-0 focus:outline-none focus:ring-0 focus:ring-offset-0 focus:ring-black focus:text-transparent focus:bg-none focus:bg-transparent bg-transparent focus:!border-black w-[30px] h-[30px] top-0 left-0 m-0 p-0"
      />
      {!!variant?.swatchImage && (
        <label
          className={`${!variant?.availableForSale &&
            'before:block before:content-[""] before:w-0.75 before:h-40 before:-top-2 before:-left-2.5 before:bg-grey-B4 before:absolute before:border before:border-white before:-rotate-45 before:origin-top-left '
            // eslint-disable-next-line max-len
            } w-[34px] h-[34px] cursor-pointer overflow-hidden peer-checked:before:bg-supergoop-blue peer-checked:border-supergoop-blue peer-checked:border relative`}
          htmlFor={`${isQuickView ? 'qw' : ''}${productId}-${value.replace(
            ' ',
            '',
          )}`}
        >
          {swatchSrc && <Image width="100%" classes="w-full" src={swatchSrc} />}
        </label>
      )}
    </div>
  );
};
const SwatchSelector = ({
  option,
  optionId,
  productId,
  handleVariantChange,
  selectedOption,
  isQuickView,
  currentVariant,
  product,
  isGiftCard
}) => (
  <div className={`${!isQuickView ? 'mb-5' : ''}`}>
    {product.variants.length > 1 && !isQuickView && (
      <label htmlFor={optionId} className="block body-xs text-grey-5C mb-1">
        <span className="mr-2.5 uppercase label-12 tracking-[2px] text-grey-2A">
          {option.name}
        </span>
        <span className="inline-block body-xs text-grey-5C">
          {selectedOption?.value}
          {currentVariant.shadeDescription
            ? `: ${currentVariant.shadeDescription}`
            : null}
        </span>

        {currentVariant.shadeMessage && (
          <span className=" utility-s !text-[12px] text-grey-2A bg-grey-F7 px-1.5 rounded">
            {currentVariant.shadeMessage}
          </span>
        )}
      </label>
    )}

    {option.values.length > 1 && (
      <div className="flex flex-wrap">
        {option.values.map((value, index) => (
          option && <OptionValue
            selectedOption={selectedOption}
            value={value}
            optionId={optionId}
            productId={productId}
            handleVariantChange={handleVariantChange}
            isQuickView={isQuickView}
            key={index}
            currentVariant={currentVariant}
            option={option}
            product={product}
            isGiftCard={isGiftCard}
          />
        ))}
      </div>
    )}

    {product.variants.length > 1 && isQuickView && (
      <label htmlFor={optionId} className="block body-xs text-grey-5C">
        {option.name}:
        <span className="inline-block ml-1 body-xs text-grey-5C">
          {selectedOption?.value}
        </span>
      </label>
    )}
  </div>
);

export default SwatchSelector;
